<template>
  <a-modal
    :title="title"
    centered
    :width="800"
    :mask-closable="false"
    :visible="showCreateAdTaskForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">

          <a-form-model-item label="媒体" prop="media">
            <a-input v-model="model.media_name" :disabled="true"/>
          </a-form-model-item>

          <a-form-model-item label="广告主" prop="advertiser_id" help="一行一个广告主，需要同一个主体" v-if="model.up_type == 2 || model.up_type == 3">
            <a-textarea v-model="model.advertiser_id" placeholder="请填写广告主" :auto-size="{ minRows: 20 }" />
          </a-form-model-item>
  
          <a-form-model-item label="广告主" prop="advertiser_id" :help="model.mediaStr == 'juliang' ? '每个主体只需要上传一个广告主，批量任务会自动推送到相关广告主':''" v-else>
            <!-- 快手：文本输入 -->
            <a-textarea
              v-if="model.mediaStr === 'kuaishou'"
              v-model="model.advertiser_id"
              placeholder="一行一个广告主ID，广告主ID之间需换行"
              :auto-size="{ minRows: 20 }"
            />

            <!-- 巨量：下拉选择 -->
            <adv-select v-else-if="model.mediaStr === 'juliang'" v-model="model.advertiser_id" :max-tag-count="1" :type="model.mediaStr" />

             <!-- 兜底（防止后续新增媒体没处理） -->
            <adv-select
              v-else
              v-model="model.advertiser_id"
              :type="model.mediaStr"
            />
          </a-form-model-item>

          <a-form-model-item label="任务名称" prop="name">
            <a-input v-model="model.name"/>
          </a-form-model-item>

        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
export default Create
</script>
